class MFRImageWithTooltips {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
          texts: ".tooltip-item__texts",
          line: ".tooltip-item__line",
          dot: ".tooltip-item__dot",
          tooltip: ".tooltip-item"
        };

        this.init();
    }

    init() {
        this.$tooltip = this.$element.find( this.selectors.tooltip );

        window.onWidthResize( this.resizeLine.bind( this ) );
        this.resizeLine();
    }

    resizeLine() {
        this.$tooltip.each((i, e) => {
            const tooltip = $(e);
            const text = tooltip.find(this.selectors.texts);
            const line = tooltip.find(this.selectors.line);
            const dot = tooltip.find(this.selectors.dot);
            const dotRec = dot.get(0).getBoundingClientRect();
            const xPosition = tooltip.hasClass( "left" ) ? dotRec.left : $(window).width() - dotRec.left - dotRec.width;
            const offset = $( window ).width() > 1023 ? 38 : 23;
            const width = xPosition - text.outerWidth() - offset;
            line.width( width );

            // if( tooltip.hasClass( "left" ) ) {
            //     console.log(i, xPosition, text.outerWidth(), offset, width);
            // }
        });
    }
}